<button title="Open mobile menu" type="button" mat-mini-fab class="fs-mobile-menu-toggle" (click)="toggleMobileMenu()" [class.fs-mobile-hidden]="mobileOpen">
  <fa-icon [icon]="faBars"></fa-icon>
</button>
<header class="header" [ngClass]="{ 'fs-close': !open, 'fs-mobile-open': mobileOpen }" [@openClose]="open ? 'open' : 'close'">
  <div class="fs-menu-header">
    <button title="Close mobile menu" type="button" mat-mini-fab class="fs-mobile-menu-toggle" (click)="toggleMobileMenu()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <fs-nav-item [label]="'Sauna-NET'" [link]="getHomeLink(auth$ | async)" [exact]="true" class="fs-logo fs-no-mobile-info" [icon]="logo">
    </fs-nav-item>
  </div>
  <div class="fs-drawer-user" *ngIf="(auth$ | async)?.isLoggedIn">
    <fs-user-navbar></fs-user-navbar>
  </div>
  <nav aria-label="fs-navigation" class="fs-navigation">
    @if((auth$ | async); as auth) { @if(auth.isLoggedIn) {
    <fs-nav-item @slideUp [link]="'/'" [exact]="true" [icon]="faHome" [label]="'Hlavni'" *ngIf="!isOfflineAuth(auth)"> </fs-nav-item>
    <fs-nav-item @slideUp [link]="'/cameras'" [icon]="'../../../assets/images/hiv_cam.png'" [label]="'Kamery'" *ngIf="camerasEnabled && !isOfflineAuth(auth)">
    </fs-nav-item>
    <!-- HARVIA -->
    <fs-nav-item
      @slideUp
      [hasChildren]="true"
      [icon]="'../../../assets/images/harvia.png'"
      label="Harvia"
      link="/harvia"
      [navClosed]="!open"
      *ngIf="!isOfflineAuth(auth)"
    >
      <nav aria-label="fs-child-navigation" class="fs-child-navigation">
        <fs-nav-item [link]="'/harvia/products'" [icon]="faBoxOpen" [label]="'Produkty'" [noRipple]="true"> </fs-nav-item>
        <fs-nav-item [link]="'/harvia/users'" [icon]="faUsers" [label]="'Uživatele'" [noRipple]="true"> </fs-nav-item>
        <fs-nav-item [link]="'/harvia/courses'" [icon]="faGraduationCap" [label]="'Školeni'" [noRipple]="true"> </fs-nav-item>
        <fs-nav-item [link]="'/harvia/texts'" [icon]="faFileLines" [label]="'Texty'" [noRipple]="true"> </fs-nav-item>
      </nav>
    </fs-nav-item>
    @if (!isOfflineAuth(auth) && canAccessServices(auth)) {
    <fs-nav-item @slideUp [link]="'/services'" [icon]="faTools" [label]="'Služby'"> </fs-nav-item>
    }
    <!-- SKLAD -->
    <fs-nav-item
      @slideUp
      link="/warehouse"
      [hasChildren]="true"
      [icon]="faWarehouse"
      label="Sklad"
      [navClosed]="!open"
      *ngIf="!isOfflineAuth(auth)"
    >
      <nav aria-label="fs-child-navigation" class="fs-child-navigation">
        <fs-nav-item link="/warehouse/inventories" [icon]="faBoxes" label="Inventury" [noRipple]="true"> </fs-nav-item>
        <fs-nav-item
          link="/warehouse/pick-ups"
          [icon]="faBoxesPacking"
          label="Výdejky"
          [hasChildren]="true"
          [noRipple]="true"
          [noToggle]="true"
        >
          <nav aria-label="fs-child-navigation" class="fs-child-navigation">
            <fs-nav-item link="/warehouse/pick-ups/deadlines" [icon]="faTableList" label="Termíny" [linkPaddingLeft]="75"> </fs-nav-item>
          </nav>
        </fs-nav-item>
        <fs-nav-item [link]="'/warehouse/defects'" [icon]="faBan" [label]="'2.jakost'"> </fs-nav-item>
        <fs-roles-guard [usersKey]="'warehouseSetsAllowedUsers'">
          <fs-nav-item [link]="'/warehouse/sets'" [icon]="faCubes" [label]="'Sety'"> </fs-nav-item>
        </fs-roles-guard>
        <fs-nav-item [link]="'/warehouse/configurator'" [icon]="faCubes" [label]="'Konfigurátor'"> </fs-nav-item>
        <fs-nav-item [link]="'/warehouse/variant-groups'" [icon]="faCubes" [label]="'Varianty'"> </fs-nav-item>
        <fs-nav-item [link]="'/warehouse/addresses'" [icon]="faMapMarkerAlt" label="Umístěni"> </fs-nav-item>
        <fs-nav-item [link]="'/warehouse/products'" [icon]="faCube" label="Produkty"> </fs-nav-item>
      </nav>
    </fs-nav-item>
    <fs-nav-item
      @slideUp
      link="/warehouse/moving-moravany"
      [hasChildren]="true"
      [icon]="faDollyFlatbed"
      label="Stěhování (M.)"
      [navClosed]="!open"
      *ngIf="showMovingMoravany"
    >
      <nav aria-label="fs-child-navigation" class="fs-child-navigation">
        <fs-nav-item
          link="/warehouse/moving-moravany/pallet-overview"
          [icon]="faTableList"
          label="Přehled palet"
          [noRipple]="true"
        ></fs-nav-item>
        <fs-nav-item
          link="/warehouse/moving-moravany/pallet-transfer-history"
          [icon]="faClockRotateLeft"
          label="Historie synchr."
          [noRipple]="true"
        ></fs-nav-item>
        <fs-nav-item link="/warehouse/moving-moravany/protocols" [icon]="faFileLines" label="Protokoly" [noRipple]="true"></fs-nav-item>
        <!-- <fs-nav-item link="/sales/automate" [icon]="faRobot" label="Automat" [noRipple]="true"> </fs-nav-item> -->
      </nav>
    </fs-nav-item>
    <!-- Pricing -->
    <fs-roles-guard [groups]="groupsPricing" usersKey="pricingAllowedUsers" *ngIf="!isOfflineAuth(auth)">
      <fs-nav-item @slideUp link="/pricing" [hasChildren]="true" [icon]="faTags" label="Cenotvorba" [navClosed]="!open">
        <nav aria-label="fs-child-navigation" class="fs-child-navigation">
          <fs-nav-item link="/pricing/sales-b2c" [icon]="faPercent" label="Slevy (b2c)" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/sales-b2b" [icon]="faPercent" label="Slevy (b2b)" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/price-creator" [icon]="faMoneyBills" label="Cenotvorba" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/b2b-pricing" [icon]="faHandshake" label="Partneři" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/competitors" [icon]="faUsers" label="Konkurence" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/stock-pairs" [icon]="faCubes" label="Skladové páry" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/price-scheduling" [icon]="faClockRotateLeft" label="Plánované změny" [noRipple]="true"> </fs-nav-item>
          <fs-nav-item link="/pricing/price-settings" [icon]="faGear" label="Nastavení" [noRipple]="true"> </fs-nav-item>
          <!-- <fs-nav-item link="/sales/automate" [icon]="faRobot" label="Automat" [noRipple]="true"> </fs-nav-item> -->
        </nav>
      </fs-nav-item>
    </fs-roles-guard>
    <fs-nav-item @slideUp link="/crm" [hasChildren]="true" [icon]="faUsers" label="CRM" [navClosed]="!open" *ngIf="!isOfflineAuth(auth)">
      <nav aria-label="fs-child-navigation" class="fs-child-navigation">
        <fs-nav-item link="/crm/contacts" [icon]="faAddressBook" label="Kontakty" [noRipple]="true"></fs-nav-item>
        <fs-nav-item link="/crm/partners" [icon]="faUserAstronaut" label="Partneři" [noRipple]="true"></fs-nav-item>
      </nav>
    </fs-nav-item>
    <fs-nav-item
      @slideUp
      [hasChildren]="true"
      [icon]="faDollyFlatbed"
      label="B2B"
      [link]="'/wholesale'"
      *ngIf="!isOfflineAuth(auth)"
      [navClosed]="!open"
    >
      <nav aria-label="fs-child-navigation" class="fs-child-navigation">
        <fs-nav-item [link]="'/wholesale/accounts'" [icon]="faUsers" [label]="'Účty'" [noRipple]="true"> </fs-nav-item>
        <fs-nav-item [link]="'/wholesale/categories'" [icon]="faTags" [label]="'Kategorie'" [noRipple]="true"> </fs-nav-item>
      </nav>
    </fs-nav-item>
    <ng-container *ngIf="canAccessAdministration(auth)">
      <fs-nav-item @slideUp [link]="'/administration'" [hasChildren]="true" [icon]="faTasks" [label]="'Administrace'" [navClosed]="!open">
        <nav aria-label="fs-child-navigation" class="fs-child-navigation">
          <fs-nav-item
            *ngIf="!isOfflineAuth(auth)"
            [link]="'/administration/synchronizer'"
            [icon]="faRobot"
            [label]="'Synchronizer'"
            [noRipple]="true"
          ></fs-nav-item>
          <ng-container *ngIf="!isSynchronizerReplayOnly(auth)">
            <fs-nav-item
              *ngIf="!isOfflineAuth(auth)"
              [link]="'/administration/mongodb'"
              [icon]="faDatabase"
              [label]="'MongoDB'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              *ngIf="!isOfflineAuth(auth)"
              [link]="'/administration/elasticsearch'"
              [icon]="faDatabase"
              [label]="'ElasticSearch'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              *ngIf="!isOfflineAuth(auth)"
              [link]="'/administration/tsql'"
              [icon]="faDatabase"
              [label]="'T-SQL'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              *ngIf="!isOfflineAuth(auth)"
              [link]="'/administration/partner-feeds'"
              [icon]="faRss"
              [label]="'Partner Feeds'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              *ngIf="!isOfflineAuth(auth)"
              [link]="'/administration/reports'"
              [icon]="faFileLines"
              [label]="'Sestavy'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              *fsCanAccess="'workGroups'"
              [link]="'/administration/work-groups'"
              [icon]="faUserGroup"
              [label]="'Pracovní skupiny'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              [link]="'/administration/offline-auth'"
              [icon]="faUserLock"
              [label]="'Offline auth'"
              [noRipple]="true"
            ></fs-nav-item>
            <fs-nav-item
              [link]="'/administration/offline-auth-audit'"
              [icon]="faFileLines"
              [label]="'Audit offline auth'"
              [noRipple]="true"
            ></fs-nav-item>
          </ng-container>
        </nav>
      </fs-nav-item>
    </ng-container>
    } }
  </nav>
  <div class="fs-toggle" (click)="toggleOpen()" matRipple>
    <fa-icon [icon]="faAngleDoubleLeft"></fa-icon>
  </div>
  <ng-content> </ng-content>
</header>
<div
  *ngIf="(auth$ | async)?.isLoggedIn"
  class="fs-mobile-backdrop"
  [ngClass]="{ 'fs-show': mobileOpen }"
  (click)="mobileOpen ? toggleMobileMenu() : false"
></div>
